var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiShareTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.205 2H11.9014L8.19526 6.2359L12.5553 12H9.14142L6.46757 8.5041L3.40808 12H1.71065L5.67475 7.46923L1.49219 2H4.9927L7.40962 5.19538L10.205 2ZM9.60962 10.9846H10.5496L4.48193 2.96205H3.47321L9.60962 10.9846Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiShareTwitter);
export default __webpack_public_path__ + "static/media/hi-share-twitter.2e3975f147c210923540ccf6569f9905.svg";
export { ForwardRef as ReactComponent };